import React, { useState, useEffect } from 'react';
import Listado from './Listado';
import ConnectedCategoriaModal from './Modal/CategoriaModal';
import CardEmpty from '../../../../Utils/Cards/CardEmpty';
import CardFormNoBorder from '../../../../Utils/Cards/CardFormNoBorder';
import Tabs, { TabPane } from 'rc-tabs';
import AnnualProjectionsLatexBudgets from './AnnualProjections/AnnualProjectionsLatexBudgets';
import AnnualProjectionsCrecimiento from './AnnualProjections/AnnualProjectionsCrecimiento';

const PlantaLatexList = (props) => {
    const { readAllShow, data, loader, readShow, data_modal, tab, setTab, edit_annual } = props;
    const { results } = data_modal;
    const [open, setOpen] = useState(false);
    const [initialValues, setInitialValues] = useState({});

    useEffect(() => {
        readAllShow();
    }, [readAllShow]);

    const openModal = () => {
        setOpen(true);
    };

    const closeModal = () => {
        setOpen(false);
        setInitialValues({});
    };
    const updateAnnual = (data) => {
        edit_annual(data);
    };

    return (
        <div className="mb-4 col-12">
            <CardFormNoBorder
                noShadow
                icon="Side_activos/Admin.svg"                                                                    
                titulo="PLANTA LÁTEX"
                subtitulo="RESUMEN"
            >
            </CardFormNoBorder>
            <Tabs
                defaultActiveKey='EN_CURSO'
                onChange={tab => setTab(tab)}
                animated={{ tabPane: true, inkBar: true }}
                moreIcon={<span className='icon-more-icon'>+</span>}
            >
                <TabPane tab='EN CURSO' key="EN_CURSO">
                    <CardEmpty noShadow
                        isMarginButtom>
                        <div className="row col-md-12 p-0">
                            <div className="col-md-6">
                                <h4 className="mr-2 titulo_principal">PLANTAS LÁTEX</h4>
                            </div>
                        </div>
                        <Listado data={data} loader={loader} openModal={openModal} readShow={readShow} {...props} />
                    </CardEmpty>
                </TabPane>

                <TabPane tab='PROYECCIONES ANUALES' key="PROYECCIONES_ANUALES">
                    <CardEmpty noShadow
                        isMarginButtom>
                        <div className="row col-md-12 p-0">
                            <div className="col-md-6">
                                <h4 className="mr-2 titulo_principal">CRECIMIENTO DE KILOS SECOS DE MAQUILLA</h4>
                            </div>
                        </div>
                        <AnnualProjectionsCrecimiento  {...props} onSubmit={updateAnnual} />
                    </CardEmpty>
                    <CardEmpty noShadow
                        isMarginButtom>
                        <div className="row col-md-12 p-0">
                            <div className="col-md-6">
                                <h4 className="mr-2 titulo_principal">PLANTAS LÁTEX ANUAL</h4>
                            </div>
                        </div>
                        <AnnualProjectionsLatexBudgets  {...props} />
                    </CardEmpty>
                </TabPane>
            </Tabs>



            <ConnectedCategoriaModal
                open={open}
                dollarExchange={data.dollar_exchange}
                closeModal={closeModal}
                initialValues={results ? results : initialValues}
                change={props.change}
                {...props}
            />

        </div>
    );
};

export default PlantaLatexList;
